export function xRayAllAction() {
  const { t } = useI18n();

  return {
    getTitle: () => t('components.xeokit_viewer.context_menu.x_ray_all') || 'X-Ray All',
    getEnabled: (context) => {
      const scene = context.viewer.scene;
      return scene.numXRayedObjects < scene.numObjects;
    },
    doAction: function (context) {
      const scene = context.viewer.scene;
      scene.setObjectsXRayed(scene.objectIds, true);
      if (!context.bimViewer.getConfig('xrayPickable')) {
        scene.setObjectsPickable(scene.objectIds, false);
      }
    },
  };
}
